export default __webpack_public_path__ + "images/YM.7e257b9.png";